import { Link } from 'react-router';
import { ButtonLink } from '@/components/ui/Button';
import { routes } from '@/routes/paths';
import { FriendSearch } from './FriendSearch';
import styles from './Friends.module.css';
import { t } from '@/lib/i18n';
import { ChevronLeftIcon } from '@/components/icons';

/**
 * A busca como página (canvas 1q). No desktop a mesma busca abre em modal a partir da lateral
 * da timeline — ver `FriendSearch`, que é o corpo compartilhado pelos dois.
 */
export function AddFriend() {
  return (
    <div className={styles.page}>
      <div className={styles.hero}>
        <div className={styles.heroNav}>
          <Link to={routes.friends} className={styles.back} aria-label={t('friends.back')}>
            <ChevronLeftIcon size={22} />
          </Link>
        </div>
        <h1 className={styles.title}>{t('friends.add')}</h1>
      </div>

      <FriendSearch />

      {/*
        A saída da tela (canvas 1q). Enviar um pedido não fecha a busca — dá para convidar
        várias pessoas seguidas —, então precisa existir um jeito de dizer "terminei" que não
        seja a seta de voltar no topo. No desktop a mesma busca vive em modal, que já tem a
        sua própria saída.
      */}
      <div className={styles.footer}>
        <ButtonLink to={routes.friends} variant="secondary" block size="lg">
          {t('friends.done')}
        </ButtonLink>
      </div>
    </div>
  );
}
